<template>
  <v-card>
    <v-card-title class="blue-grey lighten-5 text-primary">
      夕食
    </v-card-title>

    <v-form ref="post_dinner_form">

      <v-card-text class="py-3">
        <v-textarea
          v-model="content"
          :rules="[rules.required, rules.counter500]"
          label="夕食"
          auto-grow
          variant="outlined"
          density="compact"
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          @click="close"
          color="error"
          variant="text"
        >
          キャンセル
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          @click="clickPost"
          :loading="btnLoading"
          color="primary"
          variant="flat"
        >
          送信
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>

    </v-form>

  </v-card>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');
import rules from '@/service/ValidRules';

import { dailyReportModule } from '@/store/entityModules/dailyReport';

// model
import type { VForm } from 'vuetify/components';

interface DataType {
  content: string;
  btnLoading: boolean;
}

export default defineComponent({
  name: 'DinnerModal',

  props: {
    type: {
      type: String,
      default: 'post', // "post" or "edit"
    },
    dinnerId: {
      type: Number,
      default: NaN,
    },
    editContent: {
      type: String,
      default: '',
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    childId: {
      type: Number,
      default: NaN,
    },
    selectedDate: {
      type: String,
      default: dayjs().format('YYYY-MM-DD'),
    },
  },

  computed: {
    rules() {
      return rules;
    },
    form(): VForm {
      return (this.$refs as any).post_dinner_form;
    },
  },

  watch: {
    isOpen: {
      handler(val: boolean) {
        if (val) {
          this.content = '';
        }
      },
      deep: true,
    },
  },

  data: (): DataType =>({
    content: '',
    btnLoading: false,
  }),

  methods: {
    close() {
      this.$emit('close');
    },
    async clickPost() {
      const { valid } = await this.form.validate();
      if (valid) {
        this.btnLoading = true;
        try {
          if (this.type === 'post') {
            await dailyReportModule.postDinner({
              childId: this.childId,
              date: this.selectedDate,
              content: this.content,
            });
          } else if (this.type === 'edit') {
            await dailyReportModule.putDinner({
              dinnerId: this.dinnerId,
              content: this.content,
            });
          }
          this.$emit('posted');
          this.$emit('close');
          this.btnLoading = false;
        } catch (error) {
          this.$emit('close');
          this.btnLoading = false;
        }
      }
    },
  },

  mounted() {
    this.content = this.editContent;
  },
});
</script>
<style lang="scss" scoped>
</style>
